import axios from "axios";

const path = window.location.hostname;

const axiosInstance = axios.create({
  baseURL:
    path === "localhost" || path === "gray-sand-09c60820f.1.azurestaticapps.net"
      ? "https://apim-comercial-dev-eastus-001.azure-api.net/"
      : "https://apim-comercial-dev-eastus-001.azure-api.net/",
  headers: {
    "Content-Type": "application/json",
    accept: "*/*",
    "Ocp-Apim-Subscription-Key":
      path === "localhost" || path === "gray-sand-09c60820f.1.azurestaticapps.net"
        ? "c358b12a52c94fd6a7f37713e92ae75a"
        : "c358b12a52c94fd6a7f37713e92ae75a",
  },
});

export { axiosInstance };
